import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getBlogCategoryListing = createAsyncThunk(
  "blogCategoryListing/getBlogListing",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/category/get_all_data`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        {}
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const blogCategoryListingSlice = createSlice({
  name: "blogCategoryListing",
  initialState: {
    loading: false,
    blogCategoryListingData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBlogCategoryListing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBlogCategoryListing.fulfilled, (state, action) => {
        state.loading = false;
        state.blogCategoryListingData = action.payload;
      })
      .addCase(getBlogCategoryListing.rejected, (state, action) => {
        state.loading = false;
        state.blogCategoryListingData = action.payload;
        state.error = action.payload;
      });
  },
});

export default blogCategoryListingSlice.reducer;
